module.exports = __webpack_public_path__ + "static/img/wangwang.0451dd8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wangwang.jpeg
// module id = vWJD
// module chunks = 1